<template>
    <div>
        <!-- <vs-button v-if="showBtn" color="dark" size="small" @click="popUpActive=true">
            Ejecutar Quita
        </vs-button>
        <vs-popup class="mid-popup header-primary" title="Ejecutar Quita" :active.sync="popUpActive"> -->
            <!-- <vx-card> -->
                <div class="vx-row">
                    <div class="vx-col w-full mb-5">
                        <label class="bold">Indica los montos que se aplicarán como parte de la quita.</label><br>
                        <small class="bold">*IVA incluido</small>
                        <vs-table :data="discountNegotiationConcepts" class="mb-5">
                            <template slot="thead">
                                <vs-th>Concepto</vs-th>
                                <vs-th>Descuento (%)</vs-th>
                                <vs-th>Monto</vs-th>
                                <vs-th>Descuento</vs-th>
                                <vs-th>Total a pagar</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr v-for="(concept, index) in data" :key="index">
                                <vs-td>{{ concept.concept }}</vs-td>
                                <vs-td>
                                    <vs-input-number color="dark" v-model.number="concept.discount" min="0" max="100"/>
                                    <!-- <vs-input-number v-model.number="concept.discount" :disabled="concept.disabled" min="0" max="100" @input="simulateNegotiation()"/> -->
                                </vs-td>
                                <vs-td>{{ explicitMoneyFormat(concept.amount, 2) }}</vs-td>
                                <vs-td>{{ explicitMoneyFormat(concept.amountWithDiscount, 2) }}</vs-td>
                                <vs-td>{{ explicitMoneyFormat(concept.total, 2) }}</vs-td>
                                </vs-tr>
                                <vs-tr state="dark">
                                <vs-td></vs-td>
                                <vs-td></vs-td>
                                <vs-td>{{ explicitMoneyFormat(totalAmount, 2) }}</vs-td>
                                <vs-td>{{ explicitMoneyFormat(totalAmountDiscount, 2) }}</vs-td>
                                <vs-td class="bold">{{ explicitMoneyFormat(totalAmountToPay, 2) }}*</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                        <vs-alert v-if="onError" color="danger" class="mb-1" style="height: auto">{{ errorMssg }}</vs-alert>
                        <template v-if="simulationFinished">
                            <vs-alert v-if="dataResponse.applicant_available_money < dataResponse.due_payment" color="danger" class="mb-1" style="height: auto">El solicitante no cuenta con dinero disponible</vs-alert>
                            <vs-alert v-if="amortizationAmount > dataResponse.outstanding_balance" color="danger" class="mb-1" style="height: auto">La amortización a pagar no puede ser mayor al saldo insoluto</vs-alert>
                            <vs-alert v-if="interestAmount > dataResponse.interests" color="danger" class="mb-1" style="height: auto">El monto intereses no puede ser mayor al interés del proyecto</vs-alert>
                        </template>
                    </div>
                    <div class="vx-col w-full mb-4">
                        <rg-search-jira-ticket v-model="jiraTicket" />
                        <v-error v-if="hasError('jiraTicket')" :error="errorText('jiraTicket')" />
                    </div>
                    <div class="vx-col w-full mb-4">
                        <div class="mt-3 flex flex-grow justify-end">
                            <vs-button color="danger" size="small" type="filled"
                                @click="$emit('cancelled', 1)">Cancelar</vs-button>
                            <vs-button color="dark" size="small" class="ml-2" @click="executeSimulation()">
                                Calcular
                            </vs-button>
                            <vs-button :disabled="confirmBtnDisabled" class="ml-2" color="success" size="small" @click="confirmExecuteRelease()">
                                Continuar
                            </vs-button>
                        </div>
                    </div>
                </div>
            <!-- </vx-card> -->
        <!-- </vs-popup> -->
    </div>
</template>
<script>
    import formatHelper from "@mixins/formatHelper";
    import currencyHelper from "@mixins/currencyHelper";
    import AssetStatusEnum from "@/bl/enums/AssetStatusEnum";
    import RgSearchJiraTicket from "@components/misc/RgSearchJiraTicket.vue";

    export default {
        name: "ProjectDebtReduction",
        props:['projectId', 'projectAssetStatus'],
        mixins: [formatHelper, currencyHelper],
        components: {RgSearchJiraTicket },
        data(){
            return {
                popUpActive:false,
                action:null,
                simulationFinished:false,
                money: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '$',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                dataResponse: {
                    outstanding_balance:0,
                    interests:0,
                    due_payment:0,
                    applicant_available_money:0
                },
                onError: false,
                errorMssg: null,
                jiraTicket: null,
                projectsDues: {},
                totalAmount: 0,
                totalAmountDiscount: 0,
                totalAmountToPay:0,
                discountNegotiationConcepts:[
                    { value:"amortization", concept: "Amortización", discount: 0, amountWithDiscount:0, amount:0, total: 0},
                    { value:"interest", concept: "Intereses ordinarios*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
                    { value:"moratorium_interest", concept: "Intereses moratorios*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
                    { value:"penalty", concept: "Penalizaciones*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
                    { value:"client_comission", concept: "Comisiones*", discount: 0, amountWithDiscount:0, amount:0, total: 0},
                ],
            }
        },
        computed:{
            showBtn() {
                var show = true;
                if (this.projectAssetStatus != AssetStatusEnum.VIGENTE) {
                    show = false;
                }
                return show;
            },
            confirmBtnDisabled() {
                var disabled = false;
                if(!this.simulationFinished){
                    return true;
                }
                if (this.dataResponse.applicant_available_money <= 0 || this.dataResponse.applicant_available_money < this.dataResponse.due_payment) {
                    return true;
                }
                if (this.amortizationAmount > this.dataResponse.outstanding_balance) {
                    return true;
                }
                if (this.interestAmount > this.dataResponse.interests) {
                    return true;
                }
                return disabled;
            },
            amortizationAmount(){
                return this.discountNegotiationConcepts.find(c => c.value === "amortization").total??0;
            },
            interestAmount(){
                return this.discountNegotiationConcepts.find(c => c.value === "interest").total??0;
            }
        },
        async mounted() {
            this.projectsDues = {};
            this.totalAmount = 0;
            await axios.get('/api/cobranza/adeudo/' + this.projectId + '/desgloce').then(response => {
               this.projectsDues = response.data.find(d => d.project_id === this.projectId);
               this.discountNegotiationConcepts.forEach(concept => {
                  concept.amount = this.projectsDues.total[concept.value];
                  let ivaConcept = null;
                  switch (concept.value) {
                     case 'interest':
                        ivaConcept = "tax";
                        break;
                     case 'penalty':
                        ivaConcept = "penalty_tax";
                        break;
                     case 'moratorium_interest':
                        ivaConcept = "moratorium_interest_tax";
                        break;
                     case 'client_comission':
                        ivaConcept = "client_comission_tax";
                        break;
                     default:
                        break;
                  }
                  if (ivaConcept) {
                     concept.amount += this.projectsDues.total[ivaConcept];
                  }
                  this.totalAmount += concept.amount;
               });
            }).catch(error => {
               // console.log(error);
            });
        },
        methods:{
            async executeSimulation(){
                this.action = 'simulate';
                this.simulateNegotiation();
                if (!(await this.validateForm())) {
                    return;
                }
                await this.executeRelease();
            },
            async confirmExecuteRelease(){
                this.action = 'execute';
                this.simulateNegotiation();
                if (!(await this.validateForm())) {
                    return;
                }
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'success',
                    title: `Aviso`,
                    text: '¿Estas seguro de ejecutar la quita como fue calculada?',
                    acceptText: "Confirmar",
                    cancelText: "Cancelar",
                    accept: this.executeRelease
                })
            },
            async executeRelease(){
                let jiraTicketKey = null;
                if(this.action != "simulate"){
                    if (this.jiraTicket) {
                        jiraTicketKey = this.jiraTicket.key;
                    }
                }
                this.showLoading(true);
                await axios.post('/api/recoveries/executeRelease', {
                    project_id: this.projectId,
                    discount_negotiation_concepts: this.discountNegotiationConcepts,
                    // amortization: this.amortizationAmount,
                    // interests: this.interestAmount,
                    action: this.action,
                    jira_link: jiraTicketKey,
                }).then(response => {
                    this.showLoading(false);
                    if (this.action == "simulate") {
                        this.dataResponse = response.data;
                        this.simulationFinished = true;
                    } else {
                        this.successNotif("Aviso", 'Quita aplicada exitosamente', 4000);
                        this.popUpActive = false;
                        this.$emit('creditStatusUpdated', 1);
                    }
                }).catch(error => {
                    this.showLoading(false);
                    if(error.response.data.message != undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    }else{
                            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    }
                })
            },
            clean(){
                this.onError = false
                this.errorMssg = null
            },
            hasError(val) {
                return this.errors.has(val);
            },
            errorText(val) {
                return this.errors.first(val);
            },
            isSuccess(val) {
                let ff = this.fields[val];
                return ff && ff.required && ff.valid;
            },
            simulateNegotiation(){
                this.totalAmountDiscount = 0;
                this.totalAmountToPay = 0;
                this.discountNegotiationConcepts.forEach(concept => {
                    let discount = concept.discount/100;
                    let amount = concept.amount;
                    let discountAmount = amount*discount;
                    concept.amountWithDiscount = discountAmount;
                    concept.total = amount-discountAmount;

                    this.totalAmountDiscount += discountAmount;
                    this.totalAmountToPay += concept.total;
                });
            },
            async validateForm() {
                this.clean();
                if(this.amortizationAmount <= 0){
                    this.onError = true;
                    this.errorMssg = "Por favor ingresa un monto de amortización válido";
                    return false;
                }
                if(this.interestAmount < 0){
                    this.onError = true;
                    this.errorMssg = "Por favor ingresa un monto de intereses válido";
                    return false;
                }
                if(this.action != "simulate"){
                    if (!this.jiraTicket) {
                        this.onError = true;
                        this.errorMssg = "Debes indicar el ticket de Jira";
                        return false;
                    }
                }
                return true;
            },
        }
    }
</script>

<style>
.con-vs-dialog
{
    z-index: 100000 !important;
}
</style>
